<template>
  <div class="player-container">
    <div class="top-service-bar">
      <img src="@/assets/logo.png" alt="" class="img" />
      <!-- 根据登录状态显示不同内容 -->
      <div v-if="isLoggedIn" class="user-info">
        <span class="welcome-text">欢迎，{{ userName }}</span>
        <el-button type="text" @click="handleLogout" class="logout-btn">退出</el-button>
      </div>
      <div v-else>
        <el-button icon="el-icon-user-solid" class="button" @click="showLoginDialog = true">登录</el-button>
      </div>
    </div>
    <!-- 播放器容器 -->
    <div v-if="isLoggedIn && videoType == 2" class="videobox">
      <div id="player" class="player-wrapper"></div>
      <div class="videoinfo" v-if="videoInfo">
        <div class="info-right">
          <div class="title-container">
            <span class="title">{{ videoInfo.name }}</span>
            <span class="status">回放中</span>
          </div>
          <div class="teacher">暂无讲师</div>
        </div>
      </div>
    </div>
    <iframe :src="videoUrl" frameborder="0" style="width: 100%; min-height: 1250px" v-if="videoType == 1 && isLoggedIn"
      allowfullscreen="true"></iframe>

    <!-- 错误状态 -->
    <div v-if="error" class="error-overlay">
      <div class="error-content">
        <i class="el-icon-warning"></i>
        <p>{{ error }}</p>
        <el-button @click="retry">重试</el-button>
      </div>
    </div>
    <!-- 登录弹窗 -->
    <LoginDialog v-model="showLoginDialog" @login-success="handleLoginSuccess" />
  </div>
</template>
<script>
import { getVideoPlayerInfo, getWatchUrl, logout, getUserProfile } from "@/api/index.js";
// import LoginDialog from '@/components/LoginDialog.vue';

export default {
  name: "VideoPlayer",
  components: {
    // LoginDialog
  },
  data() {
    return {
      loading: true,
      error: null,
      watchCore: null,
      videoId: null,
      channelId: null,
      videoType: null, // 1-直播，2-录播
      playerInited: false,
      playStatus: false,
      liveStatus: null,
      videoInfo: null, // 视频详细信息
      classId: null, // 班级ID
      vid: null, // 视频VID
      isPublicCourse: false, // 是否为公开课
      isStrikethrough: false,
      input: "",
      isPlaying: true,
      // 回放：生产环境直接从 Polyv 官方域名加载，避免线上无 /video 代理导致 404
      vodPlayerJs: "https://player.polyv.net/resp/vod-player/latest/player.js",
      videoUrl: null,
      showLoginDialog: false, // 登录弹窗
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    userName() {
      const userInfo = this.$store.getters.userInfo;
      return userInfo.name || userInfo.username || "用户";
    },
  },
  mounted() {
    // 从URL获取基本参数
    this.videoId = this.$route.query.videoId;
    this.classId = this.$route.query.classId;
    this.isPublicCourse = this.$route.query.isPublicCourse === "true";
    this.videoType = parseInt(this.$route.query.videotype) || 2;
    // 未登录：弹出登录框并延迟初始化，不触发接口调用
    if (!this.isLoggedIn) {
      this.showLoginDialog = true;
      return;
    }
    // 已登录：按类型初始化
    if (this.videoType == 1) {
      // 直播
      this.getVideoUrl();
    } else {
      // 录播
      this.loadPlayerScript(this.loadPlayer);
    }
  },
  beforeDestroy() {
    this.destroyPlayer();
  },
  methods: {
    handleLoginSuccess(userInfo) {
      this.showLoginDialog = false;
      // 处理登录成功后的逻辑，如更新用户信息
      this.userName = userInfo.name;
    },
    //直播
    getVideoUrl() {
      getWatchUrl({ videoId: this.videoId }).then((res) => {
        this.videoUrl = res.data.watchUrl;
      });
    },

    // //回放
    async loadPlayerScript(callback) {
      const response = await getVideoPlayerInfo(this.videoId);

      if (response.code === 0 && response.data) {
        const videoData = response.data;
        this.channelId = videoData.vid; // 设置频道号
        this.vid = videoData.vid; // 设置VID
        this.videoInfo = videoData; // 保存完整视频信息
        console.log("获取视频详情成功:", videoData);

        if (!this.vid) {
          throw new Error("视频未配置VID");
        }
      } else {
        throw new Error(response.msg || "获取视频信息失败");
      }
      if (!window.polyvPlayer) {
        const myScript = document.createElement("script");
        myScript.setAttribute("src", this.vodPlayerJs);
        myScript.onload = callback;
        myScript.onerror = () => {
          console.error("播放器脚本加载失败:", this.vodPlayerJs);
          this.error = "播放器脚本加载失败，请稍后重试";
        };
        document.body.appendChild(myScript);
      } else {
        callback();
      }
    },

    loadPlayer() {
      const polyvPlayer = window.polyvPlayer;

      // 从store获取用户信息（避免重复调用API）
      const userInfo = this.$store.getters.userInfo || {};
      console.log('userInfo', userInfo)
      // 设置观众信息
      let viewerInfo = {
        viewerId: userInfo.id || '', // 用户ID
        viewerName: userInfo.name || '', // 用户姓名
        viewerAvatar: userInfo.avatar || '', // 用户头像
        viewerExtraInfo1: userInfo.username || '', // 用户名
        viewerExtraInfo2: userInfo.mobile || '', // 手机号
        viewerExtraInfo3: '' // 自定义额外信息字段3
      };

      this.player = polyvPlayer({
        wrap: "#player",
        width: "100%",
        height: "100%",
        vid: this.vid,
        showHd: true, //显示清晰度按钮
        show_rate: 2, //  允许选择的最高清晰度，取值：{1,2}。值为1时，只显示流畅，值为2时，可选流畅和高清。不设置时会显示全部清晰度。
        df: 3, //视频播放默认采用的清晰度，取值：{0,1,2,3}，分别对应自动、流畅、高清、超清。
        showLine: "on", //是否显示播放线路切换按钮，取值：{true,false}。默认为false不显示
        viewerInfo: viewerInfo
      });
    },

    // 获取视频信息
    async getVideoInfo() {
      try {
        console.log("正在获取视频详情，videoId:", this.videoId);

        // 调用播放器信息接口获取视频详情
        const response = await getVideoPlayerInfo(this.videoId);

        if (response.code === 0 && response.data) {
          const videoData = response.data;
          this.channelId = videoData.vid; // 设置频道号
          this.vid = videoData.vid; // 设置VID
          this.videoInfo = videoData; // 保存完整视频信息
          console.log("获取视频详情成功:", videoData);

          if (!this.vid) {
            throw new Error("视频未配置VID");
          }
        } else {
          throw new Error(response.msg || "获取视频信息失败");
        }
      } catch (error) {
        console.error("获取视频详情失败:", error);
        this.error = error.message || "获取视频信息失败，请稍后重试";
        throw error;
      }

      // 获取视频信息后，设置加载完成状态
      this.loading = false;
    },

    // 销毁播放器
    destroyPlayer() {
      if (this.watchCore) {
        try {
          this.watchCore.destroy();
        } catch (error) {
          console.error("销毁观看页核心失败:", error);
        }
        this.watchCore = null;
      }
    },

    // 重试
    retry() {
      this.error = null;
      this.loading = true;
      this.playerInited = false;
      this.destroyPlayer();
      this.initPlayer();
    },
    // 退出登录
    handleLogout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        logout()
          .then(() => {
            // this.clearLoginState();
            this.$store.commit("clearLoginState");
            this.$message.success("已退出登录");
          })
          .catch((error) => {
            console.error("退出登录失败:", error);
            // 即使接口失败，也清除本地存储
            this.$store.commit("clearLoginState");
            this.$message.success("已退出登录");
          });
      });
    },
    // 登录成功处理函数
    handleLoginSuccess(loginInfo) {
      // 使用Vuex action保存登录状态
      this.$store.dispatch("login", {
        token: loginInfo.token,
        refreshToken: loginInfo.refreshToken,
        userType: loginInfo.userType,
        userId: loginInfo.userId,
        tenantId: loginInfo.tenantId,
        userInfo: {},
      });

      // 获取用户详细信息
      this.fetchUserInfo();
      // 关闭登录弹窗
      this.showLoginDialog = false;
      // 登录后继续初始化播放
      if (this.videoType == 1) {
        // 直播
        this.getVideoUrl();
      } else {
        // 录播
        this.loadPlayerScript(this.loadPlayer);
      }
      this.$message.success("登录成功，欢迎回来！");
    },
    fetchUserInfo() {
      if (!this.isLoggedIn) return;

      getUserProfile()
        .then((res) => {
          if (res.data) {
            // 使用Vuex action更新用户信息
            this.$store.dispatch("updateUserInfo", res.data);
          }
        })
        .catch((error) => {
          console.error("获取用户信息失败:", error);
          // 如果获取用户信息失败，可能是token过期，清除登录状态
          this.clearLoginState();
        });
    },
  },
};
</script>

<style scoped lang="scss">
@media (max-width: 1200px) {
  .player-container {
    padding: 0 12px;
  }
}

@media (max-width: 992px) {
  .top-service-bar {
    flex-wrap: wrap;
  }

  .videobox {
    padding: 0;
  }

  .player-wrapper {
    width: 100%;
    height: 56vw;
  }

  .videoinfo {
    display: flex;
    flex-direction: column;
  }

  /* 直播 iframe 在移动端降低最小高度 */
  .player-container iframe {
    min-height: 60vh !important;
  }
}

@media (max-width: 600px) {
  .player-wrapper {
    height: 58vw;
  }

  .top-service-bar .welcome-text {
    font-size: 14px;
  }
}

.player-container {

  // position: relative;
  // background: #141518;
  // overflow: hidden;
  .top-service-bar {
    width: 90%;
    display: flex;
    justify-content: space-between;
  }

  .videobox {
    background-color: #131519;
    padding: 1.25rem;

    .player-wrapper {
      width: 100%;
      height: 700px;
    }

    .videoinfo {
      margin-top: 20px;
      width: 100%;
      height: 50px;
      background: #131519;
      display: flex;
      align-items: center;
      padding: 0 15px;
    }

    .info-right {
      display: flex;
      align-items: center;

      .title-container {
        color: #fff;
        font-size: 18px;
        margin-right: 12px;
      }

      .status {
        color: #67c23a;
        font-size: 12px;
      }

      .teacher {
        color: #909399;
        margin-left: 10px;
      }
    }
  }
}
</style>
